import Modal from '@mui/material/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { globalConfig } from '../configuration/config';
import { linkActive } from '../store/reducers/linkSlice';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

export default function OpenNewLink() {
  const { t } = useTranslation();

  const linkOpen = useSelector((state) => state.link.open);
  const projectGuid = useSelector((state) => state?.variant?.current?.projectGuid);
  const isGuidDispayType = useSelector((state) => state?.guids?.guidDisplayType);
  const calculationGuid = useSelector((state) => state?.variant?.current?.calculationGuid);
  const isCatalog = useSelector((state) => state?.project?.templateStatusOpen);
  const companyId = useSelector((state) => state?.project?.companyId);
  const dispatch = useDispatch();

  const openWidget = () => {
    if (typeof window.varwidget !== 'undefined') {
      window.varwidget.showCalculation(calculationGuid);
    }
  };

  const [modalStyle] = React.useState(getModalStyle);

  const handleClose = () => {
    dispatch(linkActive(false));
  };

  const body = (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 200,
        bgcolor: 'background.paper',
        borderRadius: 2,
        p: 2,
      }}>
      <a
        href={`${globalConfig.config.common.widget}v0/project/${projectGuid}/${calculationGuid}?companyId=${companyId}`}
        target="_blank"
        className="full-width">
        { t("openNewLink.currentVroomTab") }
      </a>
      <a className="full-width" onClick={openWidget}>
        { t("openNewLink.currentVroomModal") }
      </a>
      <a
        href={`${globalConfig.config.common.widget_new}v0/project/${projectGuid}/${calculationGuid}`}
        target="_blank"
        className="full-width">
        { t("openNewLink.newVroom") }
      </a>
      <a
        href={`${globalConfig.config.common.vroom}?calculation=${calculationGuid}&project=${
          isGuidDispayType?.length > 0 ? isGuidDispayType : projectGuid
        }&room=${projectGuid}${calculationGuid}&isCatalog=${isCatalog}`}
        target="_self"
        className="full-width">
        { t("openNewLink.oldVroom") }
      </a>
      <a
        href={`${globalConfig.config.common.remer}v0/project/${projectGuid}/${calculationGuid}`}
        target="_blank"
        className="full-width">
        { t("openNewLink.remer") }
      </a>
    </Box>
  );

  return (
    <div>
      <Modal
        open={linkOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description">
        {body}
      </Modal>
    </div>
  );
}
